import angular from 'angular';
import tasksList from './tasksList';

export default angular
  .module('components.tasksList', [])
  .component('tasksList', tasksList).name;
